import styled from 'styled-components';

export const BlueBox = styled.div`
  background-color: #2d70b7;
  height: 60px;
`;
